//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex'
import { addCart } from '../../service/index'
export default {
  name: '',
  data(){
    return {
      count: 1,
      showMoveDot: [],
      select: 0,
    }
  },
  props: ['isShow', 'closePop', 'spec', 'productPic', 'goodInfo', 'products', 'rule'],
  // 监听isShow，在弹窗显示或隐藏时，设置count = 1 
  watch:{
    isShow: {
      handler: function(after, before){
        this.count = 1;
      }
    }
  },
  computed: {
    ...mapState([
      'cartList','campaign'
    ]),
    productAndPic(){
      const result = [];
      this.productPic.length && this.productPic.map((item) => {
        this.products.map((good) => {
          if(item.goodId === good.goodId){
            result.push({...item, ...good})
          }
        })
      })
      return result;
    },
    product(){
      return this.productAndPic.length > 0 ? this.productAndPic[this.select] : {}
    },
  },
  methods: {
    ...mapMutations({
      initCart: 'INIT_CART_NUM'
    }),
    async addToCart(goodId, event){
      const param = {
        "items": [
          {
            "productId": goodId,
            "qty": this.count
          }
        ]
      }
      const res = await addCart(this.$route.query.cid, param);
      if (res.status === 0) {
        this.initCart({
          cartNum: this.count + this.cartList.cartNum,
        })

        this.$message({
          message: this.$t('cartMsg.'+res.status),
          type: 'success'
        });
        this.closePop();
        // this.$
        // let elLeft = event.target.getBoundingClientRect().left;
        // let elBottom = event.target.getBoundingClientRect().bottom;
        // this.showMoveDot.push(true);
        // this.$emit('showMoveDot', this.showMoveDot, elLeft, elBottom);
      }else {
        if (res.status !== 2) {
          this.submitFlag = false;
        }
        const message = this.$t("cartMsg."+res.status);
        if(message !== null && message !== "cartMsg."+res.status){
          this.$message(message);
        }else {
          this.$message(this.$t("cartMsg.retry"));
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cart/PopCart.vue